import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { UPDATE_GOLF_COURSE_SLOTS, UPDATE_GOLF_COURSE_SLOTS_SUCCESS, UPDATE_GOLF_COURSE_SLOTS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateGolfCourseSlots({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-slots`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: UPDATE_GOLF_COURSE_SLOTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_GOLF_COURSE_SLOTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_GOLF_COURSE_SLOTS_ERROR, payload: error });
  }
}

export function* watchUpdateGolfCourseSlots() {
  yield takeEvery(UPDATE_GOLF_COURSE_SLOTS, updateGolfCourseSlots);
}

function* updateGolfCourseSlotsSaga() {
  yield all([fork(watchUpdateGolfCourseSlots)]);
}

export default updateGolfCourseSlotsSaga;
